/**
 * site.js
 *
 * @author adwerba
 */


;(function($) {

	var site = {

		/**
		 * bootstrap
		 */
		bootstrap: function() {

			site.initOpeningTimesSwitch();
			site.initTeam();
			site.initTeamHash();
			site.initReadMoreButton();

			$("body").imagesLoaded(function() {

				site.initSlick();
				site.initSidebarLinks();

			});

		},

		initSidebarLinks: function() {

			var $infoblock = $('.sidebar-links');
			// site.checkSlickArrow();

			if ($('#wpadminbar').length > 0) {
				$infoblock.css("top", $("header").offset().top + $("header").height() + 32);
			}

			$(".sidebar-links_icon.icon--info").click(function(e) {

				e.preventDefault();
				$(".sidebar-links").toggleClass("closed");

				miniRoot.closeChildMenus();

				// setTimeout(function() {
				// 	site.checkSlickArrow();
				// }, 1000);

			});

			// @see https://stackoverflow.com/a/4326907
			var lastScrollTop = 0;

			$(window).scroll(function(event){

				var st = $(this).scrollTop();

				if (st > lastScrollTop){
					$(".sidebar-links").addClass("closed");
					// setTimeout(function() {
					// 	site.checkSlickArrow();
					// }, 1000);
				} else {
					// upscroll code
				}

				lastScrollTop = st;
			});


			// Wenn im Hauptmenü geklickt ein Eintrag geklickt wird, soll die Info immer ausgeblendet werden
			$("#mainnav .menu-item a, .main-menu-toggle").click(function() {
				$(".sidebar-links").addClass("closed");
			});

			// Bei mobil soll die Info default ausgeblendet werden (Startseite)
			if ( $(window).width() < 1340 ) {
				$(".sidebar-links").addClass("closed");
			}

		},


		initReadMoreButton: function() {

			$(".read-more-button").click(function(e) {

				e.preventDefault();

				$(this).toggleClass("opened");
				$(".md-circle-button__text").toggleClass("active");

				$(this).closest(".contentblock").find(".expandable-content").each(function() {

					$(this).toggleClass("opened");
					$(this).velocity('finish');

					if ( $(this).hasClass("opened") ) {
						$(this).velocity({
							"height": $(this).prop('scrollHeight') //JS scrollHeight liefert Höhe inkl. overflow
						});
					}

					else {
						$(this).velocity({
							"height": 0
						});
					}

				});

			});

		},

		initTeam: function() {

			$(".department-select").click(function() {

				$department = $(".team-department." + $(this).attr('data-select'));

				$(".department-select.active").removeClass("active");

				$(".team-department").velocity('finish');

				$(".team-department:visible").velocity({
					opacity: 0
				}, {
					duration: 750,
					easing: 'easeIn',
					display: "none",
					complete: function() {
//						$(this).css("display","none");
						$department.css({'display': 'block'});
						$department.velocity({
							opacity: 1
						}, {
							duration: 1000,
							easing: 'easeOut',
							display: "block"
						});
					}
				});

				$(this).addClass("active");

			});

		},

		// Auf Hashes reagieren
		initTeamHash: function() {

			var hash = location.hash;

			// Nur auf Team-Seite
			if ( $(".employees").length < 1 ) {
				return;
			}

			// Kein Hash
			if ( ! hash ) {
				return;
			}

			// Kein Element mit der ID gefunden
			if ( $(hash).length < 1 ) {
				return;
			}

			// Wir gehen von einer Abteilung aus. Wenn die Abteilung nicht exisitiert, muss es ein Mitarbeiter sein

			$department = $(hash);

			if ( $(hash).hasClass('employee') )  {
				$department = $(hash).closest(".team-department");
			}

			$(".department-select.active").removeClass("active");
			$(".team-department.active").removeClass("active");

			$(".department-select." + $department.attr('id')).addClass("active");
			$department.addClass("active");

			miniRoot.scrollTo(".team-department.active");
		},

		initSlick: function() {

			$(".fullwidth-teasers .teasers").slick({
				adaptiveHeight: true,
				//prevArrow: $("#teaser-navigation .slick-button-prev"),
				//nextArrow: $("#teaser-navigation .slick-button-next"),
				//appendDots: $("#teaser-navigation .slick-navigation-dots"),
				//dotsClass: "dots",
				//dots: true,
				dots: false,
				autoplay: true,
				autoplaySpeed: 4000,
			});

			// Alte Teaser
			if ( $(".teasers .teaser-background").length > 1 ) {

				$(".slick-navigation").css("display","block");

				$(".teasers").slick({
					adaptiveHeight: true,
					prevArrow: $(".teaser .slick-button-prev"),
					nextArrow: $(".teaser .slick-button-next"),
					appendDots: $(".teaser .slick-navigation-dots"),
					dotsClass: "dots",
					dots: true,
					asNavFor: ".teaser-headline-slider"
				});
			}

			if ( $(".teaser-headline-slider").length > 0 ) {
				$(".teaser-headline-slider").slick({
					asNavFor: ".teasers",
					arrows: false,
				});
			}

			// SEM
			$(".teaser .images").slick();

			$(".story-content").slick( {
				adaptiveHeight: true,
				prevArrow: $(".news-stories .slick-button-prev"),
				nextArrow: $(".news-stories .slick-button-next"),
				appendDots: $(".news-stories .slick-navigation-dots"),
				dotsClass: "dots",
				dots: true,
			} );

			// Contentpage

			$(".contentblock .gallery-slider").each(function() {

				$(this).slick({
					autoplay: $(this).attr("data-autoplay") === "1",
					autoplaySpeed: 3000,
				});

			})

			$(".contentblock .slides").slick();

		},



		/**
		 *
		 * Öffnungszeiten werden je nach Auswahl der Abteilung im Auswahlfelde angezeigt.
		 *
		 * Custom Select
		 * @see mini-root/site.js
		 */
		initOpeningTimesSwitch: function() {

			// Default
			$(".opening-time-department-switch").each( function() {

				$select = $(this);

				$(".opening-times ." + $select.val() ).css({'display': 'block'});
	
				// Beim Ändern
				$select.on("change", function(e, oldValue, newValue) {
	
					$scope = $(this).closest('.opening-times');
	
					$(".opening-time", $scope).css({'display': 'none'});
					$(".opening-time." + newValue, $scope).css({'display': 'block'});
	
				});

			});
		}

	};

	$(document).ready(site.bootstrap);
	$(window).resize(site.updateTeamEmployees);


})(jQuery);
